export default __webpack_public_path__ + "static/media/logo-white.29f78760.svg";